import { resetLobbyDetails } from '@/store/slices/lobby-details.slice';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { clearSession, setAccessToken } from '../session.slice';
import api from '../../../api';
import { createAccessToken } from '@/utils';
import { refreshAction } from './refresh.action';
import { HAS_SESSION_KEY } from '@/constants';

export const syncSessionAction = createAsyncThunk<void, void>(
	'auth/syncSession',
	async (_, { dispatch, getState }: any) => {
		if (!localStorage.getItem(HAS_SESSION_KEY)) {
			return;
		}

		if (localStorage.getItem(HAS_SESSION_KEY) === 'false') {
			dispatch(clearSession());
			return;
		}
		const accessToken = getState().session.access;

		const access = createAccessToken(accessToken);

		if (!access) {
			try {
				await dispatch(refreshAction()).unwrap();
			} catch {
				dispatch(clearSession());
				dispatch(resetLobbyDetails());
				dispatch(api.util.resetApiState());
			}

			return;
		}

		dispatch(setAccessToken(access));
	}
);
